module.exports = __webpack_public_path__ + "img/LouDon.91378402.png";